<template>
  <div id="app">
    <ZoomModal ref="zoomModal" :S3URL="S3URL" />

    <div class="container-fluid">
      <ProductFilter
        ref="productFilter"
        @filterChange="filter"
        @hideNav="showNav = false"
      />
      <router-view
        :S3URL="S3URL"
        :favList="favList"
        :items="items"
        :searchItems="searchItems"
        :filtersCount="filtersCount"
        :showNav="showNav"
        @removeAllFavorites="removeAllFavorites()"
        @removeFavorite="removeFavorite"
        @addFavorite="addFavorite"
        @toggleFilter="$refs.productFilter.toggle()"
        @showImage="showImage"
      />
    </div>
  </div>
</template>

<script>
import ProductFilter from "@/components/ProductFilter.vue";
import ZoomModal from "@/components/ZoomModal.vue";

export default {
  name: "app",
  components: { ProductFilter, ZoomModal },
  data: function() {
    return {
      S3URL: "http://s3.amazonaws.com/cvo-brand-img/",
      favList: [],
      selectedFilters: [],
      items: [],
      searchItems: [],
      filtersCount: 0,
      showNav: true
    };
  },
  methods: {
    showImage(obj) {
      this.$refs.zoomModal.showImage(obj);
    },
    removeAllFavorites() {
      this.favList = [];
      window.localStorage.setItem("favorites", []);
    },
    removeFavorite(itemId) {
      for (let i = 0; i < this.favList.length; i++)
        if (this.favList[i].id === itemId) {
          this.favList.splice(i, 1);
          window.localStorage.setItem(
            "favorites",
            JSON.stringify(this.favList)
          );
          return;
        }
    },
    addFavorite(item) {
      for (let variant of item.variants)
        if (variant.src === item.imagePicked) {
          var color = variant.color;
          var colorSku = variant.colorSku;
          break;
        }

      var newId = item.id.concat("|", colorSku);
      var sku = this.buildSKU(item);
      for (let favorite of this.favList) if (favorite.id === newId) return;

      let itemAdded = Object.assign({}, item);
      itemAdded.id = newId;
      itemAdded.colorPicked = color;
      itemAdded.sku = sku;

      this.favList.push(itemAdded);
      window.localStorage.setItem("favorites", JSON.stringify(this.favList));
      $("#fav-msg")
        .show()
        .fadeOut(3000); // located in product.vue
    },
    buildSKU: function(item) {
      for (let variant of item.variants)
        if (variant.src === item.imagePicked) {
          var colorSku = variant.colorSku;
          break;
        }

      var sku = item.skuPrefix.concat(colorSku);
      if (item.brand != "REVO" && item.sizePicked) {
        // must force in cart
        // var newId = item.id.concat("|", colorSku);
        // newId = newId.concat(item.sizePicked);
        sku = sku.concat(item.sizePicked);
      }
      return sku;
    },

    filter(selectedFilters) {
      var resultIds = [];
      var tempArray = [];
      var searchArray = this.items.slice();
      this.isSearching = true;

      if (selectedFilters.searchTerm.length > 0) {
        var searchTerm = selectedFilters.searchTerm.toLowerCase();
        for (let item of searchArray)
          if (
            item.model.toLowerCase().includes(searchTerm) ||
            item.features.toLowerCase().includes(searchTerm)
          )
            if (!resultIds.includes(item.id)) {
              resultIds.push(item.id);
              tempArray.push(item);
            }
        searchArray = tempArray.slice();
      } else {
        var tempCount = 0; // temp filtersCount
        $.each(selectedFilters, (index, filter) => {
          tempArray = [];
          resultIds = [];

          if (filter.length > 0) {
            for (let oneFilter of filter) {
              tempCount++;
              for (let item of searchArray)
                if (item.keywords.includes(oneFilter))
                  if (!resultIds.includes(item.id)) {
                    resultIds.push(item.id);
                    tempArray.push(item);
                  }
            }
            searchArray = tempArray.slice();
          }
        });
        this.filtersCount = tempCount;
      }
      this.searchItems = searchArray;
    }
  },
  created: function() {
    if (window.localStorage.getItem("favorites"))
      this.favList = JSON.parse(window.localStorage.getItem("favorites"));

    $.ajax({
      // Get the product items
      method: "GET",
      headers: { "x-api-key": "0kjpoTVRiX311AwcUomdo84hi85ggkiXKmunVon5" },
      url: "https://m7ah4enm09.execute-api.us-east-1.amazonaws.com/test/default"
    })
      .done(data => {
        this.items = JSON.parse(data.body).catalog.filter(
          product => product.brand === "Aspire"
        ); // filter for only aspire
        this.filter(this.$refs.productFilter.$data.selectedFilters);
      })
      .fail(() => {
        alert(
          "Failed getting list of products, check your internet connection!"
        );
      });
  }
};
</script>
